module.exports = __webpack_public_path__ + "static/media/JustActMailers_6_V2-02.0d83aaba.jpg";